package com.mgacreative.hotel.core.network

import io.github.jan.supabase.auth.SessionManager

// Tarayıcıda (JS) Supabase'in varsayılan oturum saklama mekanizması
// (localStorage tabanlı) zaten çalıştığı için burada özel bir şey
// yapmıyoruz; null dönmek Supabase'in kendi varsayılan
// SessionManager'ını kullanmasını sağlar.
actual fun providePersistentSessionManager(): SessionManager? = null
